import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const Collo = (props) => {
  const { lingua, tipoTut } = props;

  const data = useStaticQuery(graphql`
    {
      file(relativePath: { regex: "/tutorial/collo.png/" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `);

  return (
    <div className="mb-6">
      {tipoTut === "corpo" ? (
        <div>
          <GatsbyImage
            image={data.file.childImageSharp.gatsbyImageData}
            alt={lingua.tutorial.collo.titolo}
            style={{ marginBottom: "1rem" }}
          />

          <p className="is-size-6">{lingua.tutorial.collo.descrizione}</p>
        </div>
      ) : (
        <div>
          <p className="is-size-6">
            {lingua.tutorial.colloCamicia.descrizione}
          </p>
        </div>
      )}
    </div>
  );
};

export default Collo;
